import Vehicle from '../../../components/customer/vehicles/vehicle/Vehicle'

const CustomerVehicle = () => {
    return <Vehicle />
}

export default CustomerVehicle
